import { atom  } from "recoil";

export const userInput = atom({
    key: "userInput",
    default: {
        userSelectedInput : "mobileNumber",
        mobileNumber : "" ,
        email : "" ,
        newUser: false,
        mobileOtp: "",
    },
});

export const userAuthDetail = atom({
    key: "userAuth",
    default: {
        rydeSendToken: "",
        firstName: "",
        email: "",
        mobileNumber: "",
        memberType: ""
    },
});